import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Botao } from '@/components/ui/button';

export interface MetaPaginacao {
  total: number;
  pagina: number;
  limite: number;
  totalPaginas: number;
}

export interface RespostaPaginada<T> {
  dados: T[];
  meta: MetaPaginacao;
}

interface PaginacaoProps {
  meta: MetaPaginacao;
  aoMudarPagina: (pagina: number) => void;
}

export function Paginacao({ meta, aoMudarPagina }: PaginacaoProps) {
  if (meta.total === 0) return null;

  const primeiro = (meta.pagina - 1) * meta.limite + 1;
  const ultimo = Math.min(meta.pagina * meta.limite, meta.total);

  return (
    <nav
      aria-label="Paginação"
      className="mt-3 flex flex-wrap items-center justify-between gap-2 text-sm"
    >
      <p className="text-silenciado-texto" aria-live="polite">
        Exibindo <strong>{primeiro}</strong>–<strong>{ultimo}</strong> de{' '}
        <strong>{meta.total}</strong>
      </p>

      <div className="flex items-center gap-1">
        <Botao
          variante="contorno"
          tamanho="sm"
          disabled={meta.pagina <= 1}
          onClick={() => aoMudarPagina(meta.pagina - 1)}
        >
          <ChevronLeft className="size-4" aria-hidden="true" />
          Anterior
        </Botao>

        <span className="text-silenciado-texto px-2">
          Página {meta.pagina} de {meta.totalPaginas}
        </span>

        <Botao
          variante="contorno"
          tamanho="sm"
          disabled={meta.pagina >= meta.totalPaginas}
          onClick={() => aoMudarPagina(meta.pagina + 1)}
        >
          Próxima
          <ChevronRight className="size-4" aria-hidden="true" />
        </Botao>
      </div>
    </nav>
  );
}
